// NPM
import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { isNil, isEmpty } from 'lodash';

// ATOM
import { authActionStatusAtom, authPassportAtom, authErrorAtom, isAuthAtom } from 'Recoil/auth.atom';

// SERVICE
import { authBusinessAccountLogin, authLogin } from 'Services/auth.services';

// HOOKS
import useSession from 'Hooks/session.hook';

// ANT COMPONENT
import { Space } from 'antd';

// COMPONENT
import LoginForm from 'Components/auth/login-form';

// STYLE
import './login.scss';

const LoginPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [status, setStatus] = useRecoilState<any>(authActionStatusAtom);
  // const [isAuth, setIsAuth] = useRecoilState<boolean>(isAuthAtom);
  const [authPassport, setAuthPassport] = useRecoilState<any>(authPassportAtom);
  const [error, setError] = useRecoilState<any>(authErrorAtom);

  useEffect(() => {
    const session = useSession();
    if(!isEmpty(session)){
      history.push('/')
    }
    // if (isAuth && authPassport.loginFile) {
    //   history.push('/')
    // }
  }, []);

  const handleSubmit = async ({ email, password, accountType }) => {
    setStatus({ ...status, login: 'loading' });

    if (accountType === 'INDIVIDUAL_ACCOUNT') {
      const responseData: any = await authLogin({ email, password });

      if (!isNil(responseData.error)) {
        setStatus({ ...status, login: 'error' });
        setError(responseData?.error);
      }
      else {
        setStatus({ ...status, login: 'success' });
        setAuthPassport(responseData);
        // setIsAuth(true)
        // history.push('/');
      }
    } else if (accountType === 'BUSINESS_ACCOUNT') {
      const responseData: any = await authBusinessAccountLogin({ email, password });

      if (!isNil(responseData.error)) {
        setStatus({ ...status, login: 'error' });
        setError(responseData?.error);
      }
      else {
        setStatus({ ...status, login: 'success' });
        setAuthPassport(responseData);
        // setIsAuth(true)
        // history.push('/');
      }
    }
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('pageTitle.login')}</title>
        <meta name="robots" content="noindex"/>
      </Helmet>

      <div className="login-page">
        <div className="login-page--main">
          <div className="login-page--container">
            <Space direction="vertical" size="middle" className="center mb-10">
              <img
                alt={t('alt.logo')}
                src="/assets/images/marketplace-login.png"
                style={{ height: '101px' }}
              />
            </Space>

            <div className="login-page--form">
              {/* <div className="login-page--form-title">{t('title.login')}</div> */}

              <Space direction="vertical" size="middle" className="center">
                <div className="mb-30" style={{height:'50px'}} dangerouslySetInnerHTML={{ __html: t('txt.loginDescription') }} />
              </Space>
              <LoginForm
                status={status.login}
                expectedError={error}
                onSubmit={handleSubmit}
                onSuccess={() => {
                  setStatus({ ...status, login: 'idle' });
                  if (authPassport.isVerified === false) {
                    history.push('/verification');
                  }
                  else {
                    history.push('/');
                  }
                }}
              />

              {/* <Space direction="vertical" size="middle">
                <span
                  className="pt-10"
                  // here change the link
                  dangerouslySetInnerHTML={{
                    __html: t('txt.signUp', {
                      signUpLink: '/register'
                    })
                  }}
                />

                <span
                  className="pt-20"
                  dangerouslySetInnerHTML={{
                    __html: t('txt.agreementConsent', {
                      termsLink: '/terms',
                      privacyLink: '/privacy'
                    })
                  }}
                />
              </Space> */}

            </div>
            <div className="login-page--bot"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default LoginPage;
